import React from 'react'
import cx from 'classnames'
import styles from './FooterActions.module.less'

const FooterActions = ({ children, className, numButtons = 1, size }) => {
  const classNames = cx({
    [styles.footer]: true,
    [className]: !!className,
    [styles.twoButtons]: numButtons && numButtons === 2,
    [styles.sizeBigger]: size && size === "bigger",
  })

  return (
    <div className={classNames}>
      { children }
    </div>
  )
}

const FooterActionsParent = ({ children, className, numButtons = 1 }) => {
  const classNames = cx({
    [styles.bottomSpaceMobile]: numButtons !== 0,
    [className]: !!className,
  })

  return (
    <div className={classNames}>
      { children }
    </div>
  )
}

export {
  FooterActions,
  FooterActionsParent,
}